import React from 'react';
import AddSupportingDetailsStep from 'pages/components/AddSupportingDetailsStep';

const ScreeningAddSupportingDetails = (props) => (
  <AddSupportingDetailsStep {...props} />
);

export default ScreeningAddSupportingDetails;
